import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useFetcher, useLoaderData, useParams } from "react-router-dom";
import { doFetch } from "../../utils/doFetch";
import { PayrollHistoryResults } from "./PayrollHistoryResults";
import { LoadedPagesData, PayrollHistoryResultsData } from "./PayrollHistoryResultsData";

export const PayrollHistoryResultsRouteLoader = async ({ request, params }: { request: any, params: any }) => {
  const { startDate, endDate, page } = params;
  return await doFetch(`payroll-history/${startDate}/${endDate}/${page ?? 1}`, { signal: request.signal }, true, true)
}

export const PayrollHistoryResultsRoute = () => {
  const loaderData = useLoaderData();
  const fetcher = useFetcher();
  const params = useParams();
  const data = fetcher.data as PayrollHistoryResultsData ?? loaderData as PayrollHistoryResultsData;
  const loadedRecords = new Array(data.total).fill(null);
  loadedRecords.splice(0, data.records.length, ...data.records);

  const initialLoadedPagesState = {
    total: data.total,
    pageSize: data.pageSize,
    loadedRecords
  }

  const [loadedPages, setLoadedPages] = useState<LoadedPagesData>(initialLoadedPagesState);

  useEffect(() => {
    const startIndex = data.pageSize * (data.currentPage - 1);
    const endIndex = startIndex + data.records.length;

    setLoadedPages(prevState => ({
      ...prevState,
      loadedRecords: [
        ...prevState.loadedRecords.slice(0, startIndex),
        ...data.records,
        ...prevState.loadedRecords.slice(endIndex)
      ]
    }));
  }, [data.pageSize, data.records, data.total, data]);

  const onLoadNextPage = async (page: number) => {
    const { startDate, endDate } = params;
    if (!loadedPages.loadedRecords[data.pageSize * (page - 1)]) {
      await fetcher.load(`/payroll-history-results/${startDate}/${endDate}/${page}`);
    }
  };

  return (
    <PayrollHistoryResults
      data={loadedPages}
      onLoadNextPage={onLoadNextPage}
      loading={fetcher.state === 'loading'}
      currentPage={data?.currentPage ?? 1}
      startDate={dayjs(params.startDate, 'DDMMYYYY').format('MMM D, YYYY') || ''}
      endDate={dayjs(params.endDate, 'DDMMYYYY').format('MMM D, YYYY') || ''}
      noData={!data.records.length}
    />
  )
}